// Thin wrapper over the GA4 gtag.js global loaded in public/index.html. Safe to
// call when analytics is blocked or not yet loaded — it simply no-ops.

export const trackEvent = (name, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
};

export const setVariantProperty = (variant) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("set", "user_properties", { tagline_variant: variant });
  }
};
